var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStep1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A7ACB1",
  d: "M49 2.094A5.906 5.906 0 1 0 54.906 8 5.913 5.913 0 0 0 49 2.094m0 10.5a4.594 4.594 0 1 1 0-9.188 4.594 4.594 0 0 1 0 9.188"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A7ACB1",
  d: "M12 7.5h32v1H12z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2F32",
  d: "M12.688 8A5.688 5.688 0 1 1 7 2.313 5.695 5.695 0 0 1 12.688 8"
})));
export default SvgStep1;